import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

export const LANGUES = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    es: { translation: es },
  },
  lng: localStorage.getItem("mastoras_langue") || "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export function appliquerLangue(code) {
  if (code && LANGUES.some((l) => l.code === code)) {
    i18n.changeLanguage(code);
    localStorage.setItem("mastoras_langue", code);
  }
}

export default i18n;
